import { Action, Dispatch, Reducer } from 'redux';
import { EmptyRequestState } from '../../models/RequestState';
import InstanceClient from '../../services/InstanceClient';
import StatusCode from '../../util/StatusCode';

enum ClassroomToolsActionType {
    DELETE_CLASSROOM = 'DELETE_CLASSROOM',
    UPDATE_OWNER = 'UPDATE_OWNER',
}

export interface ClassroomToolsState {
    deleteClassroom: EmptyRequestState
    updateOwnerClassroom: EmptyRequestState
}

interface ClassroomTools_DeleteClassroom extends Action<ClassroomToolsActionType.DELETE_CLASSROOM> {
    deleteClassroom: EmptyRequestState
}

interface ClassroomTools_UpdateOwnerClassroom extends Action<ClassroomToolsActionType.UPDATE_OWNER> {
    updateOwnerClassroom: EmptyRequestState
}

type ClassroomToolsAction = ClassroomTools_DeleteClassroom
    | ClassroomTools_UpdateOwnerClassroom;

export const DeleteClassroom = (classroomId: string) => (dispatch: Dispatch<ClassroomTools_DeleteClassroom>) => {
    dispatch({
        type: ClassroomToolsActionType.DELETE_CLASSROOM,
        deleteClassroom: { code: StatusCode.PENDING }
    });

    return InstanceClient.delete(`/api/core/classroomadmin/classroom/tools/${classroomId}`)
        .then(() => {
            dispatch({
                type: ClassroomToolsActionType.DELETE_CLASSROOM,
                deleteClassroom: { code: StatusCode.COMPLETE }
            });

            return StatusCode.COMPLETE;
        })
        .catch(error => {
            dispatch({
                type: ClassroomToolsActionType.DELETE_CLASSROOM,
                deleteClassroom: { code: StatusCode.ERROR, error }
            });

            return StatusCode.ERROR;
        });
};

export const ClearDeleteClassroom = () => (dispatch: Dispatch<ClassroomTools_DeleteClassroom>) => {
    dispatch({
        type: ClassroomToolsActionType.DELETE_CLASSROOM,
        deleteClassroom: { code: StatusCode.NONE }
    });
};

export const ClassroomUpdateOwner = (classroomId: string, newOwner: string) => (dispatch: Dispatch<ClassroomTools_UpdateOwnerClassroom>) => {
    dispatch({
        type: ClassroomToolsActionType.UPDATE_OWNER,
        updateOwnerClassroom: { code: StatusCode.PENDING }
    });

    return InstanceClient.put(`/api/core/classroomadmin/classroom/tools/owner/${classroomId}`, { newOwner })
        .then(() => {
            dispatch({
                type: ClassroomToolsActionType.UPDATE_OWNER,
                updateOwnerClassroom: { code: StatusCode.COMPLETE }
            });
        })
        .catch(error => {
            dispatch({
                type: ClassroomToolsActionType.UPDATE_OWNER,
                updateOwnerClassroom: { code: StatusCode.ERROR, error }
            });
        });
};

export const ClearClassroomUpdateOwner = () => (dispatch: Dispatch<ClassroomTools_UpdateOwnerClassroom>) => {
    dispatch({
        type: ClassroomToolsActionType.UPDATE_OWNER,
        updateOwnerClassroom: { code: StatusCode.NONE }
    });
}


const initialState: ClassroomToolsState = {
    deleteClassroom: { code: StatusCode.NONE },
    updateOwnerClassroom: { code: StatusCode.NONE },
};

export const reducer: Reducer<ClassroomToolsState, ClassroomToolsAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case ClassroomToolsActionType.DELETE_CLASSROOM:
            return {
                ...state,
                deleteClassroom: action.deleteClassroom
            };
        case ClassroomToolsActionType.UPDATE_OWNER:
            return {
                ...state,
                updateOwnerClassroom: action.updateOwnerClassroom
            };
        default:
            return state;
    }
};